import React from 'react';
import './AdminEmptyState.css';

/**
 * @param {{
 *   title: React.ReactNode,
 *   body: React.ReactNode,
 *   action?: React.ReactNode,
 *   icon?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminEmptyState({
  title,
  body,
  action = null,
  icon = null,
  className = '',
}) {
  return (
    <section className={`au-empty-state au-scope${className ? ` ${className}` : ''}`}>
      <div className="au-empty-state__icon" aria-hidden="true">
        {icon}
      </div>
      <h2 className="au-empty-state__title">{title}</h2>
      <p className="au-empty-state__body">{body}</p>
      {action ? <div className="au-empty-state__action">{action}</div> : null}
    </section>
  );
}

export default AdminEmptyState;
